__turbopack_context__.v({
  "contactContainer": "x3Em-q_contactContainer",
  "contentRow": "x3Em-q_contentRow",
  "emailIcon": "x3Em-q_emailIcon",
  "error": "x3Em-q_error",
  "expandedSection": "x3Em-q_expandedSection",
  "form": "x3Em-q_form",
  "formContainer": "x3Em-q_formContainer",
  "formGroup": "x3Em-q_formGroup",
  "formRow": "x3Em-q_formRow",
  "header": "x3Em-q_header",
  "headerRow": "x3Em-q_headerRow",
  "heading": "x3Em-q_heading",
  "infoContainer": "x3Em-q_infoContainer",
  "input": "x3Em-q_input",
  "inputError": "x3Em-q_inputError",
  "kontakt": "x3Em-q_kontakt",
  "labelName": "x3Em-q_labelName",
  "rotated": "x3Em-q_rotated",
  "socialIcons": "x3Em-q_socialIcons",
  "submitButton": "x3Em-q_submitButton",
  "text": "x3Em-q_text",
  "textarea": "x3Em-q_textarea",
  "textareaError": "x3Em-q_textareaError",
  "threeLineEllipse": "x3Em-q_threeLineEllipse",
  "toggleButton": "x3Em-q_toggleButton",
  "wirFreuenUns": "x3Em-q_wirFreuenUns",
  "wirFreuenUnsWrapper": "x3Em-q_wirFreuenUnsWrapper",
});
